<template>
  <div class="order-delivery-page">
    <div class="toolbar">
      <a-input v-model="query.orderNo" placeholder="订单编号" class="search-item" allow-clear />
      <a-input v-model="query.customerName" placeholder="客户名称" class="search-item" allow-clear />
      <a-select v-model="query.orderStatus" placeholder="订单状态" class="search-item" allow-clear>
        <a-select-option v-for="item in statusOptions" :key="item.value" :value="item.value">
          {{ item.label }}
        </a-select-option>
      </a-select>
      <a-button type="primary" icon="search" @click="handleSearch">查询</a-button>
      <a-button icon="reload" @click="handleReset">重置</a-button>
    </div>

    <a-table
      :columns="columns"
      :data-source="data"
      rowKey="id"
      :loading="loading"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <span slot="status" slot-scope="text">
        <a-tag :color="text === '待收货' || text === '已完成' ? 'green' : 'orange'">{{ text }}</a-tag>
      </span>
      <span slot="wechatShipping" slot-scope="text"><a-tag :color="wechatShippingColor(text)">{{ text || '未触发' }}</a-tag></span>
      <span slot="action" slot-scope="text, record">
        <template v-if="record.payStatus === '已支付' && (record.orderStatus === '待发货' || record.orderStatus === '待收货')"><a @click="handleEdit(record)">{{ record.orderStatus === '待发货' ? '填写快递单号' : '更新物流进程' }}</a></template>
        <span v-else-if="record.wechatShippingStatus !== '同步失败'">--</span>
        <template v-if="record.wechatShippingStatus === '同步失败'"><a-divider type="vertical" /><a @click="retryWechatShipping(record)">重试微信同步</a></template>
      </span>
    </a-table>

    <a-modal v-model="visible" :title="form.orderStatus === '待发货' ? '订单发货' : '更新物流进程'" :width="720" @ok="handleSave">
      <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-model-item label="订单编号">
          <a-input v-model="form.orderNo" disabled />
        </a-form-model-item>
        <a-form-model-item label="客户名称">
          <a-input v-model="form.customerName" disabled />
        </a-form-model-item>
        <a-form-model-item label="收货信息">
          <a-textarea :value="receiverText" disabled :rows="3" />
        </a-form-model-item>
        <a-form-model-item v-if="form.orderStatus === '待发货' && form.deliveryType !== 'pickup'" label="快递单号">
          <a-input v-model="form.expressNo" placeholder="请输入快递单号" />
        </a-form-model-item>
        <a-form-model-item v-if="form.orderStatus === '待发货' && form.deliveryType !== 'pickup'" label="快递公司">
          <a-select v-model="form.expressCompanyId" placeholder="请选择快递公司"><a-select-option v-for="item in expressCompanies" :key="item.id" :value="item.id">{{ item.name }}（{{ item.code }}）</a-select-option></a-select>
        </a-form-model-item>
        <a-form-model-item v-if="form.orderStatus !== '待发货'" label="物流进程">
          <a-select v-model="form.logisticsStatus" placeholder="请选择物流状态"><a-select-option v-for="item in logisticsStatuses" :key="item" :value="item">{{ item }}</a-select-option></a-select>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { getOrderList, getFreightCompanies, shipOrder, retryWechatOrderShipping, appendOrderLogistics } from '@/api'

export default {
  data() {
    return {
      query: {},
      data: [],
      loading: false,
      visible: false,
      form: {},
      expressCompanies: [],
      logisticsStatuses: ['已发货', '待签收', '已签收'],
      pagination: { current: 1, pageSize: 10, total: 0 },
      statusOptions: [
        { label: '待付款', value: '待付款' },
        { label: '待发货', value: '待发货' },
        { label: '待收货', value: '待收货' },
        { label: '已完成', value: '已完成' },
        { label: '已取消', value: '已取消' }
      ],
      columns: [
        { title: '订单编号', dataIndex: 'orderNo' },
        { title: '客户', dataIndex: 'customerName' },
        { title: '手机号', dataIndex: 'customerPhone' },
        { title: '订单状态', dataIndex: 'orderStatus', scopedSlots: { customRender: 'status' } },
        { title: '支付状态', dataIndex: 'payStatus', scopedSlots: { customRender: 'status' } },
        { title: '微信发货', dataIndex: 'wechatShippingStatus', scopedSlots: { customRender: 'wechatShipping' } },
        { title: '快递单号', dataIndex: 'expressNo' },
        { title: '操作', key: 'action', width: 240, scopedSlots: { customRender: 'action' } }
      ]
    }
  },
  computed: {
    receiverText() {
      return [
        this.form.receiverName,
        this.form.receiverPhone,
        this.form.receiverAddress
      ].filter(Boolean).join(' / ')
    }
  },
  created() {
    this.loadData()
    getFreightCompanies().then(res => { this.expressCompanies = res.data || [] })
  },
  methods: {
    loadData() {
      this.loading = true
      getOrderList({
        ...this.query,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }).then(res => {
        const pageData = res.data || {}
        this.data = pageData.records || pageData.list || []
        this.pagination.total = pageData.total || 0
      }).finally(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.pagination.current = 1
      this.loadData()
    },
    handleReset() {
      this.query = {}
      this.handleSearch()
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    handleEdit(record) {
      const fallback = this.expressCompanies.find(item => item.isDefault === 1) || this.expressCompanies[0]
      this.form = {
        ...record,
        expressCompanyId: record.expressCompanyId || (fallback && fallback.id),
        logisticsStatus: '待签收'
      }
      this.visible = true
    },
    handleSave() {
      if (this.form.orderStatus === '待发货' && this.form.deliveryType !== 'pickup'
          && (!this.form.expressNo || !this.form.expressCompanyId)) {
        this.$message.warning('请完整填写快递公司和快递单号')
        return
      }
      if (this.form.orderStatus !== '待发货' && !this.form.logisticsStatus) {
        this.$message.warning('请选择物流状态')
        return
      }
      const action = this.form.orderStatus === '待发货'
        ? shipOrder(this.form.id, this.form)
        : appendOrderLogistics(this.form.id, { status: this.form.logisticsStatus })
      action.then(res => {
        const order = res.data || {}
        order.wechatShippingStatus === '同步失败' ? this.$message.warning('订单已发货，但微信发货信息同步失败') : this.$message.success('保存成功')
        this.visible = false
        this.loadData()
      })
    },
    retryWechatShipping(record) {
      retryWechatOrderShipping(record.id).then(res => {
        const order = res.data || {}
        order.wechatShippingStatus === '同步成功' ? this.$message.success('微信发货信息同步成功') : this.$message.warning(order.wechatShippingError || '微信发货信息同步失败')
        this.loadData()
      })
    },
    wechatShippingColor(status) {
      return { '同步成功': 'green', '同步失败': 'red', '无需同步': 'default' }[status] || 'orange'
    }
  }
}
</script>

<style scoped>
.order-delivery-page {
  padding: 20px;
  background: #fff;
}
.toolbar {
  margin-bottom: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.search-item {
  width: 200px;
}
</style>
